
import IDKITApi from '../libs/IDKITApi';
import { validateAccess } from '../libs/helpers';
import _const from '../const';

export default {
  data: () => ({
    isError: false,
    email: '',
    state: '',
    isChecklistEnabled: false,
    isPaymentEnabled: false,
  }),
  computed: {
    mobile() {
      return this.$q.screen.lt.md;
    },
    desktop() {
      return this.$q.screen.gt.md;
    },
    tablet() {
      return this.$q.screen.lt.lg && this.$q.screen.gt.sm;
    },
    isInvoiceEnabled() {
      return validateAccess(_const.MODULE_INVOICES);
    },
  },
  created() {
    this.$store.commit('SET_LAYOUT', 'GeneralLayout');
  },
  async mounted() {
    this.loaderShow('Validando sesión');
    try {
      await this.getIDKitData();
      this.$router.push({ name: 'auth', query: { email: this.email, state: this.state } });
    } catch (err) {
      if (!err.headers?.location) this.isError = true;
      else window.location.href = err.headers.location;
    }
  },
  methods: {
    getIDKitData() {
      return IDKITApi.validateUserSession(null, null)
        .then((res) => {
          if (!res.data.access_token) throw res;
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },

    changeViewsEnabled() {
      this.isChecklistEnabled = validateAccess(_const.MODULE_ADDITIONAL_BUDGETS);
      this.isPaymentEnabled = validateAccess(_const.MODULE_PAYMENT);
    },
  },
};
